<template>
	<div id="app">
		<!-- <transition name="van-slide-right"> -->
		<router-view>
		</router-view>
	</div>
</template>
<script>
import until from '@/api/until.js'
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import studio_login_api from '@/api/teaching_studio_no_login.js'
import tool_api from '@/api/teaching_studio_tool.js'
import { setupWechatShare } from '@/utils/wechatShareRuntime.js'
import { mapState } from 'vuex';

export default {
	data() {
		return {

		}
	},
	computed: {

	},
	components: {

	},
	watch: {
		// 切页后重设分享卡片。页面标题是各页 mounted 里设的，等一拍再取，
		// 否则首页分享出去的永远是占位标题。
		'$route'(to) {
			setTimeout(() => setupWechatShare(this.$root.app_id, to.path), 600)
		}
	},
	mounted() {
		const publicPaths = ['/login', '/register', '/warehouse/device/detail', '/sale_service']
		const hashPath = String(window.location.hash || '').split('?')[0].replace(/^#/, '')
		const isPublicPage = publicPaths.includes(hashPath) ||
			publicPaths.includes(this.$route.path) ||
			this.$route.matched.some(record => record.meta && record.meta.public)
		if (process.env.NODE_ENV != "development") {
			// Pack_change
			let app_id = until.getParameter("app_id")
			this.$root.app_id = app_id;
		}
		let token=until.getCookie("jwt_token")
		let we = until.getParameter("we")
		let login_stuio=until.getCookie("login_stuio")
		this.$root.id=login_stuio;
		if(token){
			
		}
		else{
			if (we != 'ok' && !isPublicPage) {
				setTimeout(() => {
				
					if (process.env.NODE_ENV == "development") {
						this.$router.push("/login")
					} 
					
					
				}, 1000)
			}
		}

		let guid = until.getCookie("guid")
		if (!guid) {
			guid = until.guid();
			until.setCookie("guid", guid)
		}

		if (!isPublicPage) {
			this.linkSse();
			this.getIsSuper();
			this.getUserInfo();
		}

		// 微信分享卡片：公开页也要配（售后页会分享给客户）。非微信环境内部会直接不做事。
		setTimeout(() => setupWechatShare(this.$root.app_id, this.$route.path), 800)
	},
	methods: {
	
		// 获取当前人员是否有超级权限
		async getIsSuper(){
			let res = await studio_api.Teaching_studio_apiUserIs_superGet({
                app_id: this.$root.app_id,
            })
            
            if (res.errcode == 0) {
				console.log(res);
				
                if(res.other == 'yes'){
					this.$root.isSuperRoot = true;
				}else{
					this.$root.isSuperRoot = false;
				}
            }
		},
		async getUserInfo() {
			let app_id = this.$root.app_id;
			let data = await studio_api.Teaching_studio_apiMemberLogin_userGet({ app_id });
			if (data.errcode == 0) {
				this.$root.userInfo = data.other;
			}
		},
		linkSse(){
			const eventSource = new EventSource('/teaching_studio_api/sse/send?app_id='+this.$root.app_id);  //创建一个API的stream端点

				//监听事件源的消息事件
				eventSource.onmessage = (event) => {
				console.log(`Received message: ${event.data}`);  
			};

				//监听事件源的打开事件
			eventSource.onopen = (event) => {
				console.log('Connection opened');
			};

				//监听事件源的错误事件
			eventSource.onerror = (event) => {
				console.log(`Error occurred: ${event}`);
			};
		}

	
		


	},
	watch: {
		$route(to, from) {
			this.active_path = to.path;

		},

		
		
	},


}
</script>

<style>
:root {
	--app-primary: #4e89ff;
	--app-primary-soft: #e8efff;
	--app-success: #70c76a;
	--app-success-dark: #54aa59;
	--app-warning: #f28a54;
	--app-danger: #f0645b;
	--app-ink: #1f2937;
	--app-muted: #7c8798;
	--app-border: #e8edf2;
	--app-surface: #ffffff;
	--app-canvas: #f5f8f7;
	--app-radius-sm: 10px;
	--app-radius-md: 16px;
	--app-radius-lg: 24px;
	--app-shadow-sm: 0 4px 16px rgba(31, 41, 55, 0.06);
	--app-shadow-md: 0 10px 28px rgba(31, 41, 55, 0.09);
}

*,
*::before,
*::after {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

html,
body {
	width: 100%;
	height: 100%;
	min-height: 100%;
	background: var(--app-canvas);
	color: var(--app-ink);
	font-family: "PingFang SC", "Noto Sans SC", "Microsoft YaHei", sans-serif;
	font-size: 16px;
	line-height: 1.5;
	text-wrap: pretty;
	-webkit-font-smoothing: antialiased;
	-webkit-text-size-adjust: 100%;
	overflow: hidden;
}

body {
	overscroll-behavior: none;
}

#app {
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 100dvh;
	overflow: hidden;
	background: var(--app-canvas);
}

button,
input,
textarea,
select {
	font: inherit;
}

button,
[role="button"] {
	-webkit-tap-highlight-color: transparent;
	touch-action: manipulation;
}

button:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible,
[tabindex]:focus-visible {
	outline: 3px solid rgba(78, 137, 255, 0.26);
	outline-offset: 2px;
}

input::placeholder,
textarea::placeholder {
	color: #a6afbb;
	opacity: 1;
}

::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}

::-webkit-scrollbar-thumb {
	background: rgba(124, 135, 152, 0.34);
	border-radius: 999px;
}

::-webkit-scrollbar-track {
	background: transparent;
}



.nodata_div {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin-top: 240px;
}

.nodata_div img {
	width: 387px;
	height: 287px;
}

.nodata_div .ndata_desc {
	font-size: 24px;
	line-height: 33px;
	margin-top: 60px;
	color: #999999;
}
.ni_head {
	width: 100%;
	height: 138px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 0 30px;
	box-sizing: border-box;
	overflow-x: auto;
	scrollbar-width: none;
	position: relative;
}

.nih_div {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 28px;
	color: #999999;
	line-height: 40px;
	margin-left: 48px;
	position: relative;
}

.nih_div:first-child {
	margin-left: 30px;
}

.selectnih_div {
	font-size: 36px;
	color: #333333;
	font-weight: bold;
	line-height: 50px;
}

.nih_xian {
	width: 100%;
	height: 4px;
	background: #75C969;
	border-radius: 2px;
	position: absolute;
	left: 0;
	bottom: -8px;

}

.ni_eidte {
	width: 56px;
	height: 56px;
	background: #F5F5F5;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 60px;
}

.ni_eidte .iconfont {
	font-size: 28px;
	color: #5F84FC;
}

.ni_del {
	width: 56px;
	height: 56px;
	background: #F5F5F5;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 0px;
}

.ni_del .iconfont {
	font-size: 28px;
	color: #FBA837;
}

.dialogTitleTig {
	font-size: 32px;
	font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
	font-weight: bold;
	color: #62A73A;
}

.dialogTitleTip {
	font-size: 32px;
	font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
	font-weight: bold;
	color: #EF6F38;
	width: 100%;
	text-align: center;
	margin: 0 auto;
}

.dialogTitleText {
	font-size: 0.35rem;
	color: #333333;
	margin: 1rem 0.6rem 1rem 0.6rem;
}

.tabItemT {
	height: 1.28rem !important;
	display: flex;
	align-items: center;
	justify-content: flex-start;

}

.tabItemT span {
	margin: 0 0px 0 64px;
	display: inline-block;
	box-sizing: border-box;
	height: 52px;
	line-height: 42px;
}

.scButton {
	width: 180px;
	height: 64px;
	background: #FF5C31;
	border: #FF5C31;
	border-radius: 8px;
	color: #FFFFFF;
	line-height: 37px;
	outline: none;
	font-size: 28px;
}

.returnButton {
	width: 180px;
	height: 64px;
	margin-left: 10px;
	background: #FFFFFF;
	border-radius: 8px;
	border: 1px solid #FF5C31 !important;
	font-size: 28px;
	color: #EF6F38;
	line-height: 37px;
	margin-right: 40px;
	outline: none;
}

.dialogTitleTig {
	font-size: 32px;
	font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
	font-weight: bold;
	color: #62A73A;
}

.dialogmain {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding-bottom: 40px;
}

.sure_add {
	width: calc(100% - 120px);
	margin-left: 60px;
	height: 88px;
	background: #CCCCCC;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 32px;
	color: #FFFFFF;
	margin-top: 60px;
}


.addClass {
	width: 120px;
	height: 120px;
	color: #FFFFFF;
	text-align: center;
	font-size: 100px;
	line-height: 120px;
	border-radius: 50%;
	background: linear-gradient(180deg, #75C969 0%, #D9FA76 100%);
	box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.08), -4px -4px 8px 0px rgba(0, 0, 0, 0.08);
	position: fixed;
	bottom: 5%;
	right: 10%;
	z-index: 99;
}

.add_div {
	width: 120px;
	height: 120px;
	background: linear-gradient(180deg, #75C969 0%, #D9FA76 100%);
	box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.08), -4px -4px 8px 0px rgba(0, 0, 0, 0.08);
	position: fixed;
	right: 30px;
	bottom: 30px;
	border-radius: 50%;
}

.gu_main {
	background: #FFFFFF !important;
	height: calc(100vh - 130px) !important;
	width: 100%;
	border-radius: 20px 20px 0px 0px !important;
	margin-top: -20px !important;
	position: relative !important;
	display: inline-block !important;
	box-sizing: border-box;
	overflow: auto;
	position: relative;
}

.maincontent {
	background: #FFFFFF !important;
	height: calc(100vh - 130px) !important;
	width: 100%;
	border-radius: 20px 20px 0px 0px !important;
	margin-top: -20px !important;
	position: relative !important;
	display: inline-block !important;
	box-sizing: border-box;
	overflow: auto;
	position: relative;
}

/* 父级富文本 */
.quill-editor {
	display: inline-block;
	box-sizing: border-box;
	width: 100%;
}

.ql-container {
	width: 100%;
	height: auto !important;
	font-size: 18px !important;
}
.ql-editor .ql-size-small {
  font-size: 14px !important;
}
.ql-editor .ql-size-large {
  font-size: 18px !important;
}
.ql-editor .ql-size-huge {
  font-size: 32px !important;
}

.ql-editor {
	min-height: 200px !important;
}

.vue-quill-editor {
	width: 100%;
}

.mc_div {
	width: 100%;
	display: inline-block;
	margin-top: 40px;
	padding: 0 60px;
	box-sizing: border-box;
}

.mcd_title {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	font-size: 26px;
	color: #666666;
}

.mcd_title span:first-child {

	margin-right: 8px;
}

.mcd_content {
	width: 100%;
	margin-top: 16px;
	display: flex;
	align-items: center;
	justify-content: flex-start;

}

.mcd_content input {
	width: 100%;
	height: 88px;
	border: 1px solid #E6E6E6;
	background: #ffffff;
	border-radius: 8px;
	padding-left: 30px;
	box-sizing: border-box;
	font-size: 26px;
}

.mcd_content .select_div {
	width: 100%;
	height: 88px;
	border: 1px solid #E6E6E6;
	background: #ffffff;
	border-radius: 8px;
	padding-left: 30px;
	box-sizing: border-box;
	font-size: 26px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.mcd_content textarea {
	width: 100%;
	height: 200px;
	border: 1px solid #E6E6E6;
	background: #ffffff;
	border-radius: 8px;
	padding-left: 30px;
	box-sizing: border-box;
	font-size: 26px;
	padding-top: 15px;
	resize: none;
}

.code {
	font-size: 28px;
	font-family: MicrosoftYaHei;
	color: #75C969;
	line-height: 37px;
	position: absolute;
	right: 10%;
	border-left: 1px solid #E6E6E6;
	padding-left: 30px;
}

.mcdc_addimg {
	width: 145px;
	height: 145px;
	background: #FFFFFF;
	border-radius: 8px;
	border: 1px solid #E6E6E6;
	display: flex;
	align-items: center;
	justify-content: center;
}

.mcdc_addimg img {
	height: 100%;
	width: 100%;
}


.mcdc_addimg .iconfont {
	font-size: 48px;
	color: #999999;
}

.cansure {
	background: #79CA6A;
}

.avataruploaderTip {
	position: fixed;
}

.van-ellipsis {
	font-size: 18px;
}

.changediv {
	width: 296px;
	height: 64px;
	background: #F5F5F5;
	border-radius: 43px;
	border: 1px solid #E6E6E6;
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	left: 0;
	right: 0;
	margin: 0 auto;
	bottom: 30px;
	z-index: 999;
}

.changediv .iconfont {
	font-size: 28px;
	color: #333333;
}

.changediv span {
	font-size: 28px;
	color: #333333;
	margin-left: 8px;
}
.fileMess .fileName {
	font-size: 32px;
    font-family: MicrosoftYaHei;
    color: #333333;
    line-height: 42px;
    margin-right: 24px;
}
.fileName {
	font-size: 32px;
    font-family: MicrosoftYaHei;
    color: #333333;
    line-height: 42px;
    margin-right: 24px;
}
.fileMess{
	flex: 1;
}
.audiocicle {
	position: fixed;
	right: 0;
	bottom: 50%;
	height: auto;
	width: auto;
	z-index: 999;
}
.vjs-big-play-button {
	background-color: transparent !important;
	border-radius: 50% !important;
	height: 70px !important;
	width: 70px !important;
	margin-left: -35px !important;
}
.vjs-custom-skin>.video-js .vjs-progress-control.vjs-control {
	left: 15px !important;
}
.vjs-custom-skin {
	width: 100%;
	height: 100%;
}

.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
	width: 100%;
	max-width: 100%;
	height: 100% !important;
}

.audioBottom {

}

.fileIcon {
	height: 60px;
	width: 60px;
	float: left;
	margin-right: 14px;
	display: flex;
	align-items: center;
}
.edit_div{
	width: 80px;
	height: 80px;
	background: #F5F5F5;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	right: 10px;
	top: 600px;
}
.edit_div .iconfont{
	font-size: 36px;
	color: #999999;
}
.paddingbottom{
	padding-bottom: 120px;
	
}
.buleReturnButton{
	border: 1px solid #79CA6A !important;
	color: #79CA6A;
}
.BuleScButton{
	background: #79CA6A;
}


.mc_tips{
    width: calc(100% - 120px);
    margin-left: 60px;
    padding: 16px;
    box-sizing: border-box;
    height: 186px;
    background: #F6F6F6;
    border-radius: 8px;
    margin-top: 34px;
}
.mct_top{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
}
.mct_iconfont{
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.mct_iconfont .iconfont{
    font-size: 24px;
    color: #999999;
    margin-top: 10px;
}
.mct_txt{
    font-size: 24px;
    color: #999999;
    line-height: 31px;
    text-align: left;
    margin-left: 8px;
}
.mct_bottom{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;

}
.mctb_btn{
    width: 192px;
    height: 48px;
    background: #E8ECFF;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #3F5EFF;
    line-height: 31px;
}
#txt{
    position: fixed;
    top: -10000px;
}


.link_main{
	width: 480px;
	display: inline-block;
}
.linkm_title{
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 40px;
}
.linkm_title .iconfont{
	font-size: 32px;
	color: #79CA6A;
	line-height: 32px;
}
.linkm_title span{
	font-size: 32px;
	color: #333333;
	font-weight: bold;
	margin-left: 15px;
}
.linkm_list{
	width: 100%;
	padding: 0 40px;
	box-sizing: border-box;
	
}
.ll_div{
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	margin-top: 60px;
}
.lld_img{
	width: 80px;
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.lld_img img{
	width: 100%;
	height: 100%;
}
.lld_content{
	flex: 1;
	margin-left: 24px;

}
.ldc_title{
	font-size: 28px;
	color: #333333;
	text-align: left;
	font-weight: bold;
	line-height: 37px;
}
.ldc_desc{
	width: 100%;
	text-align: left;
	font-size: 24px;
	margin-top: 8px;
}
.ldc_imgtop{
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-top: 16px;
}
.ldci_div{
	width: 140px;
	height: 120px;
}
.ldci_div img{
	width: 100%;
	height: 100%;
}
.ldci_div:last-child{
	margin-left: 16px;
}
.ldc_imgnext{
	width: 100%;
	display: inline-block;
}
.ldcinext_div{
	width: 100%;
	height: 52px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 16px;
}
.ldcinext_div img{
	width: 100%;
	height: 100%;
}
.ldcinext_div_max{
	width: 100%;
	height: 120px;
	margin-top: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.ldcinext_div_max img{
	width: 100%;
	height: 100%;
}
.know_btn{
	width: calc(100% - 60px);
	margin-left: 30px;
	height: 88px;
	background: #FFFFFF;
	border-radius: 44px;
	border: 1px solid #79CA6A;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 32px;
	color: #79CA6A;
	line-height: 42px;
	margin-top: 60px;

}

/* Shared interaction polish */
.scButton,
.returnButton,
.sure_add,
.know_btn,
.mctb_btn,
.lc_btn,
.BuleScButton,
.buleReturnButton {
	-webkit-tap-highlight-color: transparent;
	transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms ease;
}

.scButton,
.lc_btn,
.BuleScButton {
	box-shadow: var(--app-shadow-sm);
}

.scButton:active,
.returnButton:active,
.sure_add:active,
.know_btn:active,
.mctb_btn:active,
.lc_btn:active,
.BuleScButton:active,
.buleReturnButton:active {
	transform: scale(0.98);
	opacity: 0.9;
}

.scButton:disabled,
.returnButton:disabled,
.sure_add:disabled,
.lc_btn:disabled {
	cursor: not-allowed;
	opacity: 0.5;
	box-shadow: none;
}

.maincontent,
.gu_main {
	background: var(--app-surface) !important;
	box-shadow: 0 -8px 24px rgba(31, 41, 55, 0.04);
	-webkit-overflow-scrolling: touch;
	overscroll-behavior: contain;
}

.mcd_content input,
.mcd_content .select_div,
.mcd_content textarea {
	border-color: var(--app-border);
	color: var(--app-ink);
	transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.mcd_content input:focus,
.mcd_content .select_div:focus,
.mcd_content textarea:focus {
	border-color: rgba(78, 137, 255, 0.72);
	background: #fbfdff;
	box-shadow: 0 0 0 4px rgba(78, 137, 255, 0.12);
	outline: none;
}

.changediv {
	box-shadow: var(--app-shadow-sm);
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
}

.addClass,
.add_div {
	box-shadow: 0 12px 24px rgba(84, 170, 89, 0.25);
	transition: transform 180ms ease, box-shadow 180ms ease;
}

.addClass:active,
.add_div:active {
	transform: scale(0.94);
	box-shadow: 0 6px 14px rgba(84, 170, 89, 0.2);
}

.mc_tips {
	border: 1px solid rgba(124, 135, 152, 0.08);
	box-shadow: var(--app-shadow-sm);
}

.nodata_div,
.nodata_view {
	color: var(--app-muted);
}

/* Project-wide visual system */
body .home,
body .mine,
body .room,
body .data,
body .stock_scan,
body .stock_record,
body .stock_record_detail,
body .stock_print,
body .stock_detail,
body .shipment_detail,
body .shipment_record,
body .shipment_add,
body .product_material_relation,
body .product_list,
body .material_list,
body .login,
body .warehouse_manage,
body .usercode,
body .swim,
body .device_stock_detail,
body .ass_main,
body .studioadd,
body .addwarning {
	background: var(--app-canvas) !important;
	color: var(--app-ink);
}

body .record_header,
body .list_header,
body .detail_header,
body .warehouse_header,
body .popup_header {
	background: rgba(255, 255, 255, 0.94) !important;
	border-bottom: 1px solid rgba(232, 237, 242, 0.9);
	box-shadow: 0 8px 24px rgba(31, 41, 55, 0.05) !important;
	backdrop-filter: blur(12px);
	-webkit-backdrop-filter: blur(12px);
}

body .back_btn,
body .header_filter,
body .filter_btn,
body .placeholder {
	min-width: 44px;
	min-height: 44px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 14px;
}

body .back_btn:active,
body .header_filter:active,
body .filter_btn:active {
	background: var(--app-primary-soft);
	transform: scale(0.94);
}

body .back_btn i,
body .back_btn .van-icon,
body .header_filter i,
body .header_filter .van-icon,
body .filter_btn .van-icon {
	color: var(--app-ink) !important;
}

body .header_title,
body .record_title,
body .detail_title,
body .section_title {
	color: var(--app-ink) !important;
	font-weight: 700;
	letter-spacing: 0.01em;
}

body .record_item,
body .shipment_item,
body .product_card,
body .material_card,
body .preview_section,
body .preview_card,
body .shipment_preview_item,
body .min_user,
body .min_add,
body .menu_item,
body .menu_list_item,
body .minimal_card,
body .info_section,
body .detail_section,
body .hm_total,
body .hmwl_div,
body .hmtl_div,
body .dm_data_more,
body .dm_data_warning,
body .dmdwl_div {
	background: var(--app-surface) !important;
	border: 1px solid rgba(232, 237, 242, 0.9);
	border-radius: var(--app-radius-lg) !important;
	box-shadow: var(--app-shadow-sm) !important;
}

body .record_item,
body .shipment_item,
body .product_card,
body .material_card,
body .preview_card,
body .shipment_preview_item,
body .menu_item,
body .menu_list_item,
body .hmtl_div {
	transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

body .record_item:active,
body .shipment_item:active,
body .product_card:active,
body .material_card:active,
body .preview_card:active,
body .shipment_preview_item:active,
body .menu_item:active,
body .menu_list_item:active,
body .hmtl_div:active {
	transform: translateY(1px) scale(0.992);
	border-color: rgba(78, 137, 255, 0.24);
	box-shadow: 0 6px 18px rgba(31, 41, 55, 0.08) !important;
}

body .status_card {
	border: 1px solid rgba(255, 255, 255, 0.22);
	border-radius: var(--app-radius-lg) !important;
}

body .search_box,
body .dm_input,
body .wncsi_input,
body .filter_input,
body .filter_select,
body .form_input,
body .mcd_content input,
body .mcd_content .select_div,
body .mcd_content textarea,
body .lc_input input {
	background: var(--app-surface) !important;
	border: 1px solid var(--app-border) !important;
	border-radius: 14px !important;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
	color: var(--app-ink);
	transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

body .search_box:focus-within,
body .dm_input:focus-within,
body .wncsi_input:focus-within,
body .filter_input:focus-within,
body .filter_select:focus-within,
body .form_input:focus-within,
body .mcd_content input:focus,
body .mcd_content .select_div:focus,
body .mcd_content textarea:focus,
body .lc_input input:focus {
	border-color: rgba(78, 137, 255, 0.72) !important;
	background: #fbfdff !important;
	box-shadow: 0 0 0 4px rgba(78, 137, 255, 0.12) !important;
	outline: none;
}

body .search_box input,
body .dm_input input,
body .wncsi_input input,
body .filter_input input,
body .form_input input,
body .mcd_content input,
body .mcd_content textarea,
body .lc_input input {
	color: var(--app-ink);
}

body .scButton,
body .BuleScButton,
body .lc_btn,
body .action_btn.primary,
body .action_btn.confirm,
body .ship_btn,
body .cansure {
	background: linear-gradient(135deg, #4e89ff 0%, #6a9cff 100%) !important;
	border-color: transparent !important;
	border-radius: 14px !important;
	color: #fff !important;
	box-shadow: 0 8px 18px rgba(78, 137, 255, 0.22) !important;
}

body .returnButton,
body .buleReturnButton,
body .action_btn.secondary {
	background: var(--app-surface) !important;
	border: 1px solid rgba(78, 137, 255, 0.52) !important;
	border-radius: 14px !important;
	color: var(--app-primary) !important;
}

body .scButton:active,
body .BuleScButton:active,
body .lc_btn:active,
body .action_btn:active,
body .ship_btn:active,
body .returnButton:active,
body .buleReturnButton:active {
	transform: translateY(1px) scale(0.98);
	box-shadow: 0 4px 12px rgba(31, 41, 55, 0.12) !important;
}

body .add_btn,
body .addClass,
body .add_div,
body .section_float_btn {
	box-shadow: 0 12px 26px rgba(78, 137, 255, 0.25) !important;
	transition: transform 180ms ease, box-shadow 180ms ease;
}

body .add_btn:active,
body .addClass:active,
body .add_div:active,
body .section_float_btn:active {
	transform: scale(0.94);
}

body .van-button {
	font-weight: 600;
	letter-spacing: 0.01em;
	transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms ease;
}

body .van-button--primary {
	background: var(--app-primary) !important;
	border-color: var(--app-primary) !important;
}

body .van-button--success {
	background: var(--app-success-dark) !important;
	border-color: var(--app-success-dark) !important;
}

body .van-button:active {
	transform: scale(0.98);
	opacity: 0.9;
}

body .van-tabs {
	background: transparent !important;
}

body .van-tabs__line {
	background: var(--app-primary) !important;
	border-radius: 999px;
}

body .van-tab--active {
	color: var(--app-primary) !important;
	font-weight: 700;
}

body .van-cell,
body .van-field {
	color: var(--app-ink);
	background: var(--app-surface);
}

body .van-cell::after {
	border-color: var(--app-border);
}

body .van-popup,
body .van-action-sheet {
	background: var(--app-surface);
	border-radius: 24px 24px 0 0 !important;
	overflow: hidden;
}

body .van-dialog {
	border-radius: var(--app-radius-lg) !important;
	overflow: hidden;
}

body .van-dialog__header {
	color: var(--app-ink);
	font-weight: 700;
}

body .van-tag--primary {
	background: var(--app-primary-soft) !important;
	color: var(--app-primary) !important;
}

body .van-tag--success {
	background: #e9f7ed !important;
	color: var(--app-success-dark) !important;
}

body .empty_state,
body .empty_tip,
body .preview_empty,
body .nodata_view,
body .nodata_div,
body .loading_state,
body .loading_wrap {
	color: var(--app-muted);
}

body .empty_state img,
body .nodata_view img,
body .nodata_div img {
	opacity: 0.9;
}

body .rm_left,
body .rm_right {
	border: 1px solid rgba(232, 237, 242, 0.9);
	box-shadow: var(--app-shadow-sm);
}

body .selectrmldl_div,
body .selecthmth,
body .selectnih_div {
	color: var(--app-primary) !important;
}

body .selectrmldl_div .rmldl_xian,
body .hmth_xian,
body .nih_xian {
	background: var(--app-primary) !important;
}

body .dm_head {
	background: linear-gradient(135deg, #4e89ff 0%, #6a9cff 100%) !important;
	box-shadow: 0 12px 28px rgba(78, 137, 255, 0.2);
}

body .login_content {
	box-shadow: 0 -10px 26px rgba(31, 41, 55, 0.06);
}

body .login .register span {
	color: var(--app-primary) !important;
}

body .footermain {
	height: calc(98px + env(safe-area-inset-bottom));
	padding-bottom: env(safe-area-inset-bottom);
	background: rgba(255, 255, 255, 0.94) !important;
	border-top: 1px solid rgba(232, 237, 242, 0.9);
	box-shadow: 0 -8px 24px rgba(31, 41, 55, 0.08);
	backdrop-filter: blur(14px);
	-webkit-backdrop-filter: blur(14px);
	z-index: 100;
}

body .footermain .f_div {
	min-height: 64px;
	gap: 4px;
	font-weight: 500;
	transition: color 160ms ease, transform 160ms ease;
}

body .footermain .f_div:active {
	transform: scale(0.94);
}

body .footermain .selectf_div {
	color: var(--app-primary) !important;
	font-weight: 700;
}

body .footermain .f_div img {
	transition: transform 160ms ease;
}

body .footermain .selectf_div img {
	transform: translateY(-1px);
}

@media (max-width: 360px) {
	body .record_item,
	body .shipment_item,
	body .product_card,
	body .material_card,
	body .preview_section,
	body .min_user,
	body .min_add,
	body .menu_item,
	body .menu_list_item {
		border-radius: 18px !important;
	}

	body .search_row {
		gap: 8px;
	}
}

@media (max-width: 360px) {
	.ni_head {
		padding-left: 18px;
		padding-right: 18px;
	}

	.nih_div:first-child {
		margin-left: 18px;
	}

	.mc_div {
		padding-left: 24px;
		padding-right: 24px;
	}

	.sure_add,
	.mc_tips {
		width: calc(100% - 48px);
		margin-left: 24px;
	}
}

@media (prefers-reduced-motion: reduce) {
	*,
	*::before,
	*::after {
		animation-duration: 0.01ms !important;
		animation-iteration-count: 1 !important;
		scroll-behavior: auto !important;
		transition-duration: 0.01ms !important;
	}
}


</style>
